module.exports = __webpack_public_path__ + "img/changing.92a0030b.svg";